module.exports = __webpack_public_path__ + "static/media/dd_personales.ff02a9ad.svg";